import { MainV3ApiBase } from './base';
import { SessionIndexView, SessionShowView, SessionType } from '../types/sessions';
import { SessionId } from '../../commonv3/types/sessions';

type FindAllParams = {
  session_type: SessionType;
  only_reservable: 'true' | 'false';
};

export const SessionApis = {
  base() {
    return MainV3ApiBase.appendPath('sessions');
  },
  findAll(params: Partial<FindAllParams> = {}): Promise<SessionIndexView[]> {
    return this.base().get(params);
  },
  show(sessionId: SessionId): Promise<SessionShowView> {
    return this.base().withId(sessionId).get();
  },
};
